export const resultadoItems = { category: "resultados", key: "resultados", name: "Resultados" }
